import { render, staticRenderFns } from "./TextWithTooltip.vue?vue&type=template&id=470a3ab7&scoped=true"
import script from "./TextWithTooltip.vue?vue&type=script&lang=ts"
export * from "./TextWithTooltip.vue?vue&type=script&lang=ts"
import style0 from "./TextWithTooltip.vue?vue&type=style&index=0&id=470a3ab7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a3ab7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
